(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  let footerTopTitles = document.querySelectorAll('.footer .columns .title');
  footerTopTitles.forEach((title) => {
    title.addEventListener('click', function () {
      title.closest('div').classList.toggle('expanded');
    });
  });
  window.addEventListener('DOMContentLoaded', function () {
    document.body.append(document.querySelector('.footer-bottom'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  let productTypeLabel = document.querySelector('.mobile-facets__summary.caracterisiticas');
  if (productTypeLabel) {
    productTypeLabel.remove();
  }

  let newSubmenu = document.querySelector('.product-type-submenu');
  let productTypeSubmenu = document.querySelector('.mobile-facets__submenu.caracterisiticas');
  if (productTypeSubmenu) {
    let duplicatedMenu = productTypeSubmenu.cloneNode(true);
    duplicatedMenu.querySelectorAll('input').forEach((input) => {
      input.setAttribute('data-id', input.getAttribute('id'));
      input.removeAttribute('id');
      input.closest('.mobile-facets__label').addEventListener('click', function () {
        input.checked = !input.checked;
      });
    });
    newSubmenu.appendChild(duplicatedMenu);
    productTypeSubmenu.classList.add('hide');
  }

  } catch(e) { console.error(e); }
})();
})();
